/*
 * Cart trigger popup: shows a popup block (sections/popups.liquid, block type "cart_trigger")
 * when a product from the block's collection is added to the cart.
 * Listens to the theme's "krown:cart:add" event (detail.variantId).
 */
(() => {

	const popups = Array.from(document.querySelectorAll('modal-box[data-cart-trigger]'));
	if ( popups.length === 0 ) return;

	const root = ( window.Shopify && Shopify.routes && Shopify.routes.root ) || '/';
	const collectionCache = {};

	// product ids of a collection, cached per page load and in sessionStorage
	const collectionProductIds = async handle => {
		if ( collectionCache[handle] ) return collectionCache[handle];
		const key = `cart-trigger-collection-${handle}`;
		try {
			const stored = sessionStorage.getItem(key);
			if ( stored ) {
				collectionCache[handle] = JSON.parse(stored);
				return collectionCache[handle];
			}
		} catch (e) {}
		const ids = [];
		for ( let page = 1; page <= 4; page++ ) {
			const response = await fetch(`${root}collections/${handle}/products.json?limit=250&page=${page}`);
			if ( ! response.ok ) break;
			const data = await response.json();
			data.products.forEach(product => ids.push(product.id));
			if ( data.products.length < 250 ) break;
		}
		collectionCache[handle] = ids;
		try { sessionStorage.setItem(key, JSON.stringify(ids)); } catch (e) {}
		return ids;
	};

	const productIdForVariant = async variantId => {
		const response = await fetch(`${root}cart.js`);
		if ( ! response.ok ) return null;
		const cart = await response.json();
		const line = cart.items.find(item => String(item.variant_id) === String(variantId));
		return line ? line.product_id : null;
	};

	const canShow = popup => {
		const frequency = popup.dataset.frequency || 'session';
		const key = `cart-trigger-${document.location.hostname}-${popup.id}`;
		if ( frequency === 'always' ) return true;
		try {
			if ( frequency === 'session' ) return ! sessionStorage.getItem(key);
			const shown = parseInt(localStorage.getItem(key) || '0');
			if ( ! shown ) return true;
			const seconds = ( Date.now() - shown ) / 1000;
			if ( frequency === 'day' ) return seconds > 86400;
			if ( frequency === 'week' ) return seconds > 604800;
			return false; // once
		} catch (e) {
			return true;
		}
	};

	const remember = popup => {
		const frequency = popup.dataset.frequency || 'session';
		const key = `cart-trigger-${document.location.hostname}-${popup.id}`;
		try {
			if ( frequency === 'session' ) sessionStorage.setItem(key, '1');
			else if ( frequency !== 'always' ) localStorage.setItem(key, String(Date.now()));
		} catch (e) {}
	};

	let busy = false;

	document.addEventListener('krown:cart:add', async e => {

		const variantId = e.detail && e.detail.variantId;
		if ( ! variantId || busy ) return;

		const candidates = popups.filter(popup => popup.dataset.collection && canShow(popup));
		if ( candidates.length === 0 ) return;

		busy = true;
		try {
			const productId = await productIdForVariant(variantId);
			if ( ! productId ) return;

			for ( const popup of candidates ) {
				const ids = await collectionProductIds(popup.dataset.collection);
				if ( ids.includes(productId) ) {
					const delay = parseFloat(popup.dataset.delay || '1') * 1000;
					setTimeout(() => {
						popup.show();
						remember(popup);
					}, delay);
					break; // one popup at a time
				}
			}
		} catch (err) {
			console.log(err);
		} finally {
			busy = false;
		}

	});

})();
